/* lib/is_present.js - verifies that a JS object is not empty. */

/* Copyright (c) 2020 - present Tikkl, Inc. */

/*
modification history
--------------------
01b,30aug22,mno  named exports.
01a,03mar20,mno  created.
*/

import isEmpty from './is_empty';

const isPresent = (obj) => !isEmpty(obj);

export default isPresent;